var isObject = {};
export {
  isObject as __exports
};
//# sourceMappingURL=isObject.js.map
